import { useEffect, useRef, useState } from 'react';

export const useKeyEvents = (
  key: string,
  callback: (e: KeyboardEvent) => void
) => {
  const [keyPressed, setKeyPressed] = useState(false);
  const onKeyPressed = useRef(callback);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === key) {
        setKeyPressed(true);
        onKeyPressed.current(e);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [key]);

  useEffect(() => {
    onKeyPressed.current = callback;
  }, [callback]);

  return keyPressed;
};
